import { getDefaultExportFromCjs as e } from "../../_virtual/_commonjsHelpers.js";
import { t as a } from "./toString.js";
var o = a;
function n() {
  var r = arguments, t = o(r[0]);
  return r.length < 3 ? t : t.replace(r[1], r[2]);
}
var p = n;
const s = /* @__PURE__ */ e(p);
export {
  s as default
};
//# sourceMappingURL=replace.js.map
